export class Verification {
    phonenumberoremail: string = "";
    lang: string = "";
}

export class MetodoVerificacao {    
    code: string = "";
    value: string = "";
    lable: string = "";
    icon: string = "";
}